import type { PaymentMilestoneStatus } from "./Payments";
export enum PaymentScheduleBalanceMode {
    UseEnteredScheduleTotal = 1,
    RecalculateFromMilestones = 2,
}

export interface DiaryPaymentMilestoneDto {
    milestoneId: number;
    diaryItemId: number;

    sequenceNumber: number;

    label?: string | null;
    dueUtc?: string | null;

    amount: number;
    amountPaid: number;
    amountOutstanding: number;

    status: PaymentMilestoneStatus;

    canEditAmount: boolean;
    canEditDueDate: boolean;
    canDelete: boolean;
    canCancel: boolean;
    canRestore: boolean;

    rowVersion: string;
}

export interface PaymentScheduleSummaryDto {
    paymentScheduleId: number;
    parentDiaryItemId: number;

    title: string;
    currencyCode: string;

    totalAmount: number;
    totalPaid: number;
    totalOutstanding: number;

    nextDueUtc?: string | null;

    plannedMilestoneCount: number;
    paidMilestoneCount: number;

    visibility: number;

    reminderOffsetsMinutes: number[];

    milestones: DiaryPaymentMilestoneDto[];

    canChangeCurrency: boolean;

    rowVersion: string;
}

export interface PaymentMilestoneUpdateDto {
    milestoneId?: number | null;
    diaryItemId?: number | null;

    sequenceNumber: number;

    label?: string | null;
    dueUtc?: string | null;

    amount: number;

    status: PaymentMilestoneStatus;

    rowVersion?: string | null;
}

export interface PaymentScheduleUpdateDto {
    paymentScheduleId: number;

    artworkId: number;

    title?: string | null;
    description?: string | null;

    currencyCode: string;
    totalAmount: number;

    balanceMode: PaymentScheduleBalanceMode;

    visibility: number;

    milestones: PaymentMilestoneUpdateDto[];

    reminderOffsetsMinutes: number[];

    rowVersion: string;
}